<template lang="html">
  <div class="numcardcontainer" @click="flipped=!flipped">
    <div class="numcard" :class="{flipped: flipped}">
      <div class="number">{{numberShown}}</div>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  data(){
    return {
      flipped: false
    }
  },
  props: {
    num: {
      type: Number,
      required: true
    },
    baseNumber: {
      type: Number,
      required: true
    }
  },
  computed:{
    numberShown(){
      if (this.flipped) {
        return this.baseNumber-this.num
      }else{
        return this.num
      }
    }
  },
  watch:{

  },
  mounted(){
    const tl = gsap.timeline()
    tl.to('.numcard', {duration:1, display:"flex", stagger:0.3, opacity:1})
  }
}
</script>

<style lang="scss">
.numcardcontainer{
  display: flex;
  align-items: center;
  justify-content: center;
}
.numcard{
  display: none;
  opacity:0;
  position: relative;
  z-index: 50;
  width: 120px;
  height: 170px;
  background: blue;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 90px;
  border-radius: 8px;
  transform: rotateY(360deg);
  box-shadow: 3px 3px 2px 1px #ccc;
  transition: transform 0.27s ease-out;

  // &:after{
  //   position: absolute;
  //   content: "";
  //   z-index: -1 !important;
  //   bottom: 15px;
  //   right: 8px;
  //   top: 80%;
  //   width: 50%;
  //   background: #777;
  //   -webkit-box-shadow: 0 18px 15px #486685;
  //   -moz-box-shadow: 0 18px 15px #486685;
  //   box-shadow: 0 18px 15px #486685;
  //   -webkit-transform: rotate(4deg);
  //   -moz-transform: rotate(4deg);
  //   -o-transform: rotate(4deg);
  //   -ms-transform: rotate(4deg);
  //   transform: rotate(4deg);
  // }
  .number{
    transition: transform 0.27s ease-out;
    transform: rotateY(0deg);
  }

  &.flipped{
    background: pink;
    color: black;
    transition: transform 0.27s ease-out;
    transform: rotateY(180deg);
    box-shadow: 3px 3px 2px 1px #ccc;

    .number{
      transition: transform 0.33s ease-out;
      transform: rotateY(180deg);

    }
  }
}


</style>
